"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMinMaxBounds = void 0;
function updateMinMaxBounds(objA, objB) {
    if (!objB)
        return objA;
    if (objB.minElement > objA.minElement)
        objA.minElement = objB.minElement;
    if (objB.maxElement > objA.maxElement)
        objA.maxElement = objB.maxElement;
    return objA;
}
exports.updateMinMaxBounds = updateMinMaxBounds;
